import Vue from 'vue'
import login from '@/views/login/login.vue'
import order from '@/views/order/orderIndex.vue'
import print from '@/views/reportForm/components/print.vue'
// import addreserve from '@/views/reserve/components/addreserve.vue'
import VueRouter from 'vue-router'
import dashboard from '@/views/dashboard/rouConfig'
import BusinessStatus from '@/views/BusinessStatus/rouConfig'
import MenuQuery from '@/views/MenuQuery/rouConfig'
import maintenance from '@/views/maintenance/rouConfig'
import reserve from '@/views/reserve/rouConfig'
import addreserve from '@/views/reserve/rouConfig'
import reportForm from '@/views/reportForm/rouConfig'
import breakfast from '@/views/breakfast/rouConfig'
Vue.use(VueRouter)

import Layout from '@/views/layout/Layout'
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export const constantRouterMap = [
  // { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  // { path: '/authredirect', component: () => import('@/views/login/authredirect'), hidden: true },
  // { path: '/404', component: () => import('@/views/errorPage/404'), hidden: true },
  // { path: '/401', component: () => import('@/views/errorPage/401'), hidden: true },

  {
    path: '/login',
    name: 'login',
    component: login
  }, {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [{
      path: 'dashboard',
      component: () => import('@/views/dashboard/index'),
      name: 'dashboard',
      meta: {
        title: 'dashboard',
        icon: 'dashboard',
        noCache: true
      }
    }]
  },
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    children: [
      ...dashboard,
      ...maintenance,
      // ...BusinessStatus,
      ...MenuQuery,
      ...reserve,
      ...reportForm,
      ...breakfast,
    ]
  }, {
    path: '/order',
    name: 'order',
    component: order
  }, {
    path: '/addreserve',
    name: 'addreserve',
    component: addreserve
  }, {
    path: '/print',
    name: 'print',
    component: print
  }, {
    path: '*',
    redirect: "/login",
    hidden: true
  }
]

export default new VueRouter({
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
})